import { useCallback } from 'react';
import { useGetRouteStationsPricesByStationCode } from 'entities/stations';

import { Station } from 'dataSources/Typicode/stations';

export const useFilterTop5Stations = () => {
  const getRouteStationsPricesByStationCode = useGetRouteStationsPricesByStationCode();

  const filterTop5Stations = useCallback(
    (stations: Station[], serviceCodes: number[], priceType: string) =>
      stations
        .reduce(
          (acc, station) => {
            const stationServices = getRouteStationsPricesByStationCode(station.code)?.services || [];
            const stationServicePrices = stationServices.find(
              ({ service }) => service.code.toString() === serviceCodes[0].toString()
            );
            const stationServicePrice = {
              amount: stationServicePrices?.clientPriceNettoInEuro,
              currency: 'EUR',
            };

            if (stationServicePrice.amount !== undefined && stationServicePrice.amount !== null) {
              acc.push({
                station,
                servicePriceInEUR: Number(stationServicePrice.amount),
              });
            }

            return acc;
          },
          [] as { station: Station; servicePriceInEUR: number }[]
        )
        .sort((firstStation, secondStation) =>
          firstStation.servicePriceInEUR > secondStation.servicePriceInEUR ? 1 : -1
        )
        .slice(0, 5)
        .map((item) => item.station),
    [getRouteStationsPricesByStationCode]
  );

  return filterTop5Stations;
};
